import { Form } from "@circle-react-uikit/Form";
import { FormCommunityMemberSelect } from "@circle-react-uikit/Form/FormCommunityMemberSelect";
import { FormSection } from "@circle-react/components/SpaceGroups/NewFormV3/FormSection";

import { t } from "@/i18n-js/instance";

export const Moderators = () => (
  <FormSection title={t("space_groups.form.moderators")}>
    <Form.Item
      translationRoot="space_groups.form.edit"
      name="moderator_community_member_ids"
      tooltipText={t(
        "space_groups.form.edit.moderator_community_member_ids_tooltip",
      )}
      hideDescription
      hideBorder
      fullWidth
      isFirstChild
    >
      <FormCommunityMemberSelect
        name="moderator_community_member_ids"
        variant="tags"
        excludeAdmins
      />
    </Form.Item>
  </FormSection>
);
